import React from "react";
import {injectIntl} from "react-intl";

class GreenCardLightbox extends React.Component {

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div id="green-card" className="light-box-overlay">
                <div className="light-box">
                    <a className="light-box-close" id="greenCardLightboxClose" onClick={(e) => this.props.handle(e)}>
                        {formatMessage({id: "content.lightbox.close"})}
                    </a>
                    <p className="header-text">The Modern Green Card (2010 – present)</p>
                    <img title="The Modern Green Card (2010 – present)" alt="The Modern Green Card (2010 – present)"
                         src="/assets-static/images/expire-date-highlight-green-card-large.png"/>
                </div>
                <div className="light-box-bg"></div>
            </div>
        )
    }
}

export default injectIntl(GreenCardLightbox);
